import React from 'react';

export const DeleteCard = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
        >
            <path
                d="M14.1667 18.3333H5.83333C4.91286 18.3333 4.16667 17.5871 4.16667 16.6666V5.83329H2.5V4.16663H5.83333V3.33329C5.83333 2.41282 6.57953 1.66663 7.5 1.66663H12.5C13.4205 1.66663 14.1667 2.41282 14.1667 3.33329V4.16663H17.5V5.83329H15.8333V16.6666C15.8333 17.5871 15.0871 18.3333 14.1667 18.3333ZM5.83333 5.83329V16.6666H14.1667V5.83329H5.83333ZM7.5 3.33329V4.16663H12.5V3.33329H7.5ZM12.5 15H10.8333V7.49996H12.5V15ZM9.16667 15H7.5V7.49996H9.16667V15Z"
                fill="#757575"
            />
        </svg>
    );
};
